// extracted by mini-css-extract-plugin
module.exports = {"modal":"reject-modal_modal__37uun","checkbox":"reject-modal_checkbox__1NOKc","typing":"reject-modal_typing__4Y-h2"};